export const BANK_QUERY_KEY = {
  BANK_RULES: 'BANK_RULE',
  BANK_TRANSACTION_MATCHES: 'BANK_TRANSACTION_MATCHES',
  RECOGNIZED_BANK_TRANSACTION: 'RECOGNIZED_BANK_TRANSACTION',
  EXCLUDED_BANK_TRANSACTIONS_INFINITY: 'EXCLUDED_BANK_TRANSACTIONS_INFINITY',
  RECOGNIZED_BANK_TRANSACTIONS_INFINITY:
    'RECOGNIZED_BANK_TRANSACTIONS_INFINITY',
  BANK_ACCOUNT_SUMMARY_META: 'BANK_ACCOUNT_SUMMARY_META',
  AUTOFILL_CATEGORIZE_BANK_TRANSACTION: 'AUTOFILL_CATEGORIZE_BANK_TRANSACTION',
  PENDING_BANK_ACCOUNT_TRANSACTIONS: 'PENDING_BANK_ACCOUNT_TRANSACTIONS',
  PENDING_BANK_ACCOUNT_TRANSACTIONS_INFINITY:
    'PENDING_BANK_ACCOUNT_TRANSACTIONS_INFINITY',
};
